import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { TeamsPage } from '@/features/admin';

/** Teams also appear under Organisation; this keeps older links working. */
export const Route = createFileRoute('/_app/admin/teams')({
  staticData: { crumb: 'admin:nav.teams' },
  beforeLoad: ({ context }) => requirePermission(context.queryClient, 'admin.users', 'Setup'),
  component: TeamsPage,
});
